import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { updateWidget, getWidget } from './actions'
import Form from 'pages/widgets/form'
import R from 'ramda'

const mapState = R.applySpec({
  initialValues: R.prop('widget')
})

const mapDispatch = {
  onSubmit: updateWidget,
  getWidget
}

export class EditContainer extends Component {
  componentDidMount () {
    const { getWidget, id } = this.props

    getWidget(id)
  }

  render () {
    const { onSubmit, id, ...props } = this.props

    return <Form onSubmit={onSubmit(id)} widgetId={id} {...props} />
  }
}

EditContainer.propTypes = {
  getWidget: PropTypes.func,
  id: PropTypes.string,
  onSubmit: PropTypes.func
}

export default connect(mapState, mapDispatch)(EditContainer)



// WEBPACK FOOTER //
// ./src/pages/widgets/form-actions/edit/index.js